var getPanelId = function (id, index) { return "".concat(id, "-panel-").concat(index); };
var getTabId = function (id, index) { return "".concat(id, "-tab-").concat(index); };

export { getPanelId, getTabId };
//# sourceMappingURL=generateIds.js.map
